export default __webpack_public_path__ + "static/media/cat.2260c664.png";